import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/16/solid';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const NavButton = ({ back = false, title, ...rest }) => {
	return (
		<div className="inline-block">
			<Link
				{...rest}
				className={cn(
					'btn',
					'btn-sm',
					'btn-primary',
					'flex',
					'flex-row',
					'flex-nowrap',
					'gap-1',
					'inline-block',
					{ 'pr-1': !back && !isEmpty(title), 'pl-1': back && !isEmpty(title) },
				)}
			>
				{back && <ChevronLeftIcon className="w-6 h-6" />}
				{title}
				{!back && <ChevronRightIcon className="w-6 h-6" />}
			</Link>
		</div>
	);
};

NavButton.propTypes = {
	back: PropTypes.bool,
	title: PropTypes.string.isRequired,
};

export default NavButton;
